// Contains all solutions-related constants and methods - used in Embercom, so importing from the constants-strings.

import {
    ARTICLES_ESSENTIAL_ID,
    ARTICLES_PRO_ID,
    CORE_ACCELERATE_ID,
    CORE_ENGAGE_PRO_ID, CORE_START_ID, CORE_STARTER_BASE_ID,
    CORE_SUPPORT_PRO_ID, FIN_AI_COPILOT_BASE_ID,
    INBOX_ESSENTIAL_ID,
    INBOX_PRO_ID,
    MESSAGES_ESSENTIAL_ID,
    MESSAGES_PRO_ID,
    OPERATOR_PRO_ID, PEOPLE_REACHED_TIER_1_ID,
    PEOPLE_REACHED_TIER_2_ID, PRICING_5_X_CORE_ADVANCED_ID, PRICING_5_X_CORE_ESSENTIAL_ID, PRICING_5_X_CORE_EXPERT_ID,
    PROACTIVE_MESSAGING_BASE_ID, PROACTIVE_SUPPORT_BASE_ID, PROACTIVE_SUPPORT_PLUS_BASE_ID,
    PRODUCT_TOURS_ESSENTIAL_ID,
    FIN_FOR_PLATFORMS_BASE_ID,
    // @ts-ignore
} from "./constants-strings.js";

export const VBP_MAR2021_EARLY_STAGE_SEP2021_SOLUTION_ID = '20'; // VBP 2.0 Early Stage with Support, Engage and Product Tours
export const VALUE_BASED_PRICING_FEB2022_STARTER_SOLUTION_ID = '21'; // VBP 2.1 Starter (Self Serve)

// Pricing 5 solutions
export const PRICING_5_0_ESSENTIAL_SOLUTION_ID = '24';
export const PRICING_5_0_ADVANCED_SOLUTION_ID = '25';
export const PRICING_5_X_EARLY_STAGE_SOLUTION_ID = '26';
export const PRICING_5_X_EARLY_STAGE_FREE_SOLUTION_ID = '27';
export const PRICING_5_1_ESSENTIAL_SOLUTION_ID = '28';
export const PRICING_5_1_ADVANCED_SOLUTION_ID = '29';
export const PRICING_5_1_EXPERT_SOLUTION_ID = '30';

export const FIN_FOR_PLATFORMS_CORE_SOLUTION_ID = '31';

export const PRICING_5_X_ADVANCED_SOLUTION_IDS = [
    PRICING_5_0_ADVANCED_SOLUTION_ID,
    PRICING_5_1_ADVANCED_SOLUTION_ID,
];

export const PRICING_5_X_ESSENTIAL_SOLUTION_IDS = [
    PRICING_5_0_ESSENTIAL_SOLUTION_ID,
    PRICING_5_1_ESSENTIAL_SOLUTION_ID,
];

// Only some solutions can be selected for annual billing.
export const OFFERED_SELF_SERVE_ANNUALLY_BILLED_SOLUTIONS = [
    VALUE_BASED_PRICING_FEB2022_STARTER_SOLUTION_ID,
];


export const VBP_2_X_EARLY_STAGE_SOLUTION_IDS = [VBP_MAR2021_EARLY_STAGE_SEP2021_SOLUTION_ID];
export const PRICING_5_X_EARLY_STAGE_SOLUTION_IDS = [
    PRICING_5_X_EARLY_STAGE_SOLUTION_ID,
    PRICING_5_X_EARLY_STAGE_FREE_SOLUTION_ID,
];

export const EARLY_STAGE_SOLUTION_IDS = [
    ...VBP_2_X_EARLY_STAGE_SOLUTION_IDS,
    ...PRICING_5_X_EARLY_STAGE_SOLUTION_IDS,
];

export const CURRENT_EARLY_STAGE_SOLUTION_IDS = [
    ...VBP_2_X_EARLY_STAGE_SOLUTION_IDS,
    ...PRICING_5_X_EARLY_STAGE_SOLUTION_IDS,
];



export const VBP_SOLUTION_IDS = [
    VALUE_BASED_PRICING_FEB2022_STARTER_SOLUTION_ID,
    ...VBP_2_X_EARLY_STAGE_SOLUTION_IDS,
];

export const PRICING_5_X_SOLUTION_IDS_NON_EARLY_STAGE = [
    PRICING_5_0_ESSENTIAL_SOLUTION_ID,
    PRICING_5_0_ADVANCED_SOLUTION_ID,
    PRICING_5_1_ESSENTIAL_SOLUTION_ID,
    PRICING_5_1_ADVANCED_SOLUTION_ID,
    PRICING_5_1_EXPERT_SOLUTION_ID,
];

export const PRICING_5_SOLUTION_IDS = [
    PRICING_5_0_ESSENTIAL_SOLUTION_ID,
    PRICING_5_0_ADVANCED_SOLUTION_ID,
    PRICING_5_X_EARLY_STAGE_SOLUTION_ID,
    PRICING_5_X_EARLY_STAGE_FREE_SOLUTION_ID,
    PRICING_5_1_ESSENTIAL_SOLUTION_ID,
    PRICING_5_1_ADVANCED_SOLUTION_ID,
    PRICING_5_1_EXPERT_SOLUTION_ID,
];

export const FIN_FOR_PLATFORMS_SOLUTION_IDS = [
    FIN_FOR_PLATFORMS_CORE_SOLUTION_ID,
];

export const EARLY_STAGE_BUNDLE = [
    INBOX_PRO_ID,
    MESSAGES_PRO_ID,
    ARTICLES_PRO_ID,
    OPERATOR_PRO_ID,
    PRODUCT_TOURS_ESSENTIAL_ID,
];

export const CORE_EARLY_STAGE_BUNDLE = [CORE_ACCELERATE_ID, PRODUCT_TOURS_ESSENTIAL_ID];

export const CORE_EARLY_STAGE_ENGAGEMENT_BUNDLE = [
    CORE_ACCELERATE_ID,
    PRODUCT_TOURS_ESSENTIAL_ID,
    PROACTIVE_MESSAGING_BASE_ID,
];

export const VBP_MAR2021_EARLY_STAGE_SEP2021_BUNDLE = [
    CORE_SUPPORT_PRO_ID,
    CORE_ENGAGE_PRO_ID,
    PRODUCT_TOURS_ESSENTIAL_ID,
    PEOPLE_REACHED_TIER_2_ID,
];

export const PRICING_5_EARLY_STAGE_BUNDLE = [
    PRICING_5_X_CORE_ADVANCED_ID,
    PROACTIVE_SUPPORT_PLUS_BASE_ID,
    FIN_AI_COPILOT_BASE_ID,
];

// removed ARTICLES_ESSENTIAL_ID from solution 7 and 8 to fix bug
export const SOLUTION_PLAN_IDS: { [key: number]: string[] } = {
    1: [INBOX_ESSENTIAL_ID, ARTICLES_ESSENTIAL_ID], // The legacy pro version had [INBOX_PRO_ID, ARTICLES_ESSENTIAL_ID]
    2: [INBOX_ESSENTIAL_ID, MESSAGES_ESSENTIAL_ID], // The legacy pro version had [INBOX_PRO_ID, MESSAGES_PRO_ID],
    3: [MESSAGES_ESSENTIAL_ID], // The legacy pro version had [MESSAGES_PRO_ID]
    4: [INBOX_ESSENTIAL_ID, MESSAGES_ESSENTIAL_ID], // The legacy pro version had [INBOX_PRO_ID, MESSAGES_PRO_ID],
    5: [ARTICLES_ESSENTIAL_ID],
    7: [INBOX_ESSENTIAL_ID], // The legacy pro version had [INBOX_PRO_ID]
    8: [INBOX_ESSENTIAL_ID, MESSAGES_ESSENTIAL_ID], // The legacy pro version had [INBOX_PRO_ID, MESSAGES_PRO_ID],
    9: [INBOX_ESSENTIAL_ID, MESSAGES_ESSENTIAL_ID], // The legacy pro version had [INBOX_PRO_ID, MESSAGES_PRO_ID],
    10: EARLY_STAGE_BUNDLE,
    11: [INBOX_ESSENTIAL_ID, MESSAGES_ESSENTIAL_ID], // The legacy pro version had [INBOX_PRO_ID, MESSAGES_PRO_ID],
    12: [INBOX_ESSENTIAL_ID], // The legacy pro version had [INBOX_PRO_ID],
    13: [INBOX_ESSENTIAL_ID], // The legacy pro version had [INBOX_PRO_ID],
    14: [CORE_START_ID], // The legacy pro version had [CORE_GROW_ID],
    15: CORE_EARLY_STAGE_BUNDLE,
    16: [CORE_START_ID], // The legacy pro version had [CORE_GROW_ID],
    17: CORE_EARLY_STAGE_BUNDLE,
    18: [CORE_STARTER_BASE_ID],
    19: CORE_EARLY_STAGE_ENGAGEMENT_BUNDLE,
    20: VBP_MAR2021_EARLY_STAGE_SEP2021_BUNDLE,
    21: [CORE_STARTER_BASE_ID],
    22: [CORE_SUPPORT_PRO_ID, PROACTIVE_SUPPORT_BASE_ID, PEOPLE_REACHED_TIER_1_ID],
    24: [PRICING_5_X_CORE_ESSENTIAL_ID],
    25: [PRICING_5_X_CORE_ADVANCED_ID],
    26: PRICING_5_EARLY_STAGE_BUNDLE,
    27: PRICING_5_EARLY_STAGE_BUNDLE,
    28: [PRICING_5_X_CORE_ESSENTIAL_ID],
    29: [PRICING_5_X_CORE_ADVANCED_ID],
    30: [PRICING_5_X_CORE_EXPERT_ID],
    31: [FIN_FOR_PLATFORMS_BASE_ID],
};

export const CORE_EARLY_STAGE_FREE_COUPON_CODE = 'EarlyStageCoreCouponStarter';
export const CORE_EARLY_STAGE_VBP_1_0_COUPON_CODE = 'EarlyStageCoreCouponStandard';
export const CORE_EARLY_STAGE_VBP_1_2_COUPON_CODE = 'EarlyStageCoreCouponFeb2021Standard';
export const CORE_EARLY_STAGE_VBP_1_2_ENGAGEMENT_COUPON_CODE =
    'EarlyStageCoreCouponFeb2021EngagementStandard';
export const VBP_MAR2021_EARLY_STAGE_SEP2021_COUPON_CODE = 'EarlyStageValueBasedPricingSep2021';

export function earlyStageCouponCodeForSolution(solutionId: string, free: boolean) {
    // @ts-ignore
    if (free && VBP_2_X_EARLY_STAGE_SOLUTION_IDS.includes(solutionId)) {
        return CORE_EARLY_STAGE_FREE_COUPON_CODE;
    }

    switch (solutionId) {
        case VBP_MAR2021_EARLY_STAGE_SEP2021_SOLUTION_ID:
            return VBP_MAR2021_EARLY_STAGE_SEP2021_COUPON_CODE;
        default:
            return undefined;
    }
}

/**
 * The only supported models for non-Early Stage self-serve signups is Pricing 5.
 *
 * When a new sign up comes with an Early Stage solution id we change it to the VBP 2 equivalent
 * Otherwise, if the solution id is not Pricing 5, we redirect to Pricing 5 Essential
 *
 * This can happen when tampering with the solution_id query param in the url or following an old redirect
 */
export function getSolutionIdInActivePricingModel(solutionId: string) {
    // @ts-ignore
    if (PRICING_5_SOLUTION_IDS.includes(solutionId)) {
        return solutionId;
    }

    if (solutionId === VBP_MAR2021_EARLY_STAGE_SEP2021_SOLUTION_ID) {
        return VBP_MAR2021_EARLY_STAGE_SEP2021_SOLUTION_ID;
    }

    if (solutionId === VALUE_BASED_PRICING_FEB2022_STARTER_SOLUTION_ID) {
        return VALUE_BASED_PRICING_FEB2022_STARTER_SOLUTION_ID;
    }

    if (solutionId === FIN_FOR_PLATFORMS_CORE_SOLUTION_ID) {
        return FIN_FOR_PLATFORMS_CORE_SOLUTION_ID;
    }

    return PRICING_5_1_ESSENTIAL_SOLUTION_ID;
}

export function isEarlyStageSolution(solutionId: string) {
    // @ts-ignore
    return EARLY_STAGE_SOLUTION_IDS.includes(solutionId);
}

export function plansFromSolution(solutionId: number) {
    return SOLUTION_PLAN_IDS[solutionId] || [];
}

export function minimumSeatsForSolutionId(solutionId: string) {
    switch (solutionId) {
        case VALUE_BASED_PRICING_FEB2022_STARTER_SOLUTION_ID:
            return 2;
        default:
            return 0;
    }
}

const year1Discounts: { [key: string]: number } = {
    [PRICING_5_X_EARLY_STAGE_SOLUTION_ID]: 90,
    [VBP_MAR2021_EARLY_STAGE_SEP2021_SOLUTION_ID]: 95,
};

export function percentDiscountForSolution(solutionId: string, year = 1) {
    switch (year) {
        case 1:
            return year1Discounts[solutionId] ?? 100;
        case 2:
            return 50;
        case 3:
            return 25;
        default:
            return 0;
    }
}

export function defaultSolutionId(planId: string) {
    switch (planId) {
        case PRICING_5_X_CORE_ESSENTIAL_ID:
            return PRICING_5_1_ESSENTIAL_SOLUTION_ID;
        case PRICING_5_X_CORE_ADVANCED_ID:
            return PRICING_5_1_ADVANCED_SOLUTION_ID;
        case PRICING_5_X_CORE_EXPERT_ID:
            return PRICING_5_1_EXPERT_SOLUTION_ID;
        default:
            throw new Error('Invalid planId provided - no solutionId available for this plan');
    }
}
